import qs from 'qs';
import isEmpty from 'lodash/isEmpty';
import { fetchApi, getUserId, getOrganisationId } from 'shared/functions';
import { defaultPreferences } from 'shared/constants/news/defaultPreferences';

export const fetchArtifacts = async ({
  entityId,
  query,
  filters,
  type,
  page,
  limit,
  industryCode,
}) => {
  const userId = getUserId();

  const params = {
    page,
    limit,
  };

  const innerFilters =
    filters && !isEmpty(filters)
      ? `,${Object.keys(filters)
          .map(key => {
            const val = filters[key];
            const valStr = JSON.stringify(val);
            const value = Array.isArray(val) ? valStr : `"${valStr}"`;
            return `{"property": "${key}", "value": ${value}}`;
          })
          .join(',')}`
      : '';

  const filtersMap = {
    ENTITY_RATING_NEWS: `[{"property":"issuerIds","value":["${entityId}"]},
    {"property":"type","value":["RATING_NEWS","MONITORING_NOTES"]}${innerFilters}]`,
    RATING_NEWS: `[{"property":"type","value":["RATING_NEWS", "MONITORING_NOTES"]},
    {"property":"query","value":"${query}"}${innerFilters}]`,
    RESEARCH: `[{"property":"type","value":["COMMENTARY","RESEARCH"]},
    {"property":"query","value":"${query}"}${innerFilters}]`,
    INDUSTRY_RESEARCH: `[{"property":"type","value":["COMMENTARY","RESEARCH"]},
    {"property":"classification","value":["${industryCode}"]}${innerFilters}]`,
    DASHBOARD_NEWS: `[{"property":"query","value":"${query}"}${innerFilters}]`,
  };

  const filter = encodeURIComponent(filtersMap[type]);

  return fetchApi(
    `/storefront/users/${userId}/scope-news-es?${qs.stringify(params)}&filter=${filter}`,
  ).then(response => response.json());
};

export const fetchAnnouncement = async ({ id, lang }) => {
  const params = {
    lang,
    start: 0,
    limit: 10,
  };

  return fetchApi(`/storefront/announcements/${id}?${qs.stringify(params)}`).then(response =>
    response.json(),
  );
};

const mapCountriesListObject = countriesList =>
  countriesList ? { countryCode: countriesList.join(';') } : {};

export const savePreferences = async ({ emailNotifications, newsFeed, newsletter }) => {
  const organisationId = getOrganisationId();
  const userId = getUserId();

  const resourceUrl = `/sso/organisations/${organisationId}/users/${userId}/preferences`;

  const body = {
    preferences: {
      emailNotifications: {
        ...emailNotifications,
      },
      newsFeed: {
        news: newsFeed.newsTypes,
        limitToFollowedAnalysts: newsFeed.limitToFollowedAnalysts,
        classifications: [
          {
            classificationStandardCode: 'TnR',
            classificationType: 'INDUSTRY',
            values: newsFeed.industryTypes.map(({ code }) => code),
          },
        ],
        ...mapCountriesListObject(newsFeed.countriesList),
      },
      newsletter: {
        news: newsletter.newsTypes,
        limitToFollowedAnalysts: newsletter.limitToFollowedAnalysts,
        frequency: newsletter.frequency,
        useNewsFeedPreferences: newsletter.useNewsFeedPreferences,
        classifications: [
          {
            classificationStandardCode: 'TnR',
            classificationType: 'INDUSTRY',
            values: newsletter.industryTypes.map(({ code }) => code),
          },
        ],
        ...mapCountriesListObject(newsletter.countriesList),
      },
    },
  };

  const params = {
    method: 'PUT',
    body: JSON.stringify(body),
  };

  return fetchApi(resourceUrl, params);
};

export const fetchPreferences = async ({ defaultPrefs = false }) => {
  const organisationId = getOrganisationId();
  const userId = getUserId();

  if (defaultPrefs) {
    return defaultPreferences;
  }

  try {
    return await fetchApi(
      `/sso/organisations/${organisationId}/users/${userId}/preferences`,
    ).then(response => response.json());
  } catch (e) {
    throw new Error('Failed to fetch preferences: ', e);
  }
};
